import MasterCrudPage from "@/components/MasterCrudPage";

export default function HolidayCalendar() {
  return (
    <MasterCrudPage
      endpoint="/masters/holiday-calendar"
      title="Holiday Calendar"
      breadcrumbs={["Masters", "Holidays"]}
      testIdPrefix="holiday"
      initialForm={{ is_active: true, skip_recurring_task: true }}
      columns={[
        { key: "date", label: "Date", width: 140 },
        { key: "holiday_name", label: "Holiday" },
        { key: "skip_recurring_task", label: "Skip Recurring", render: r => r.skip_recurring_task ? "Yes" : "No" },
      ]}
      formFields={[
        { key: "date", label: "Date", type: "date", required: true },
        { key: "holiday_name", label: "Holiday Name", required: true },
        { key: "skip_recurring_task", label: "Skip Recurring", type: "checkbox" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
